import Vue from 'vue'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import HighchartsMore from 'highcharts/highcharts-more'
import { getNormalizedLocale } from '@/helpers/i18n.helpers'
import i18n from './i18n'
import { EN_LOCALE } from '@/constants/locales'

if(getNormalizedLocale() !== EN_LOCALE) {
  Highcharts.setOptions({
    lang: i18n.t('chart')
  })
}

Vue.use(HighchartsVue, {
	highcharts: HighchartsMore(Highcharts)
})


// WEBPACK FOOTER //
// ./src/plugins/highchartsLanguageConfig.js